export default __webpack_public_path__ + "static/media/store.cdbff7b3.svg";